
var THREE          = require("three");

var AbstractSelectableObject3dView = function (model) {
    var self = this;
    this.model = model;

};

module.exports = AbstractSelectableObject3dView;

